import { animated } from '@react-spring/web';
import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

interface ContentProps {
    width?: string;
}

export const AnimatedContent = styled(animated.div)<ContentProps>`
    padding: ${theme.space[4]} ${theme.space[8]};
    box-shadow: ${theme.shadows.medium};
    background-color: ${theme.colors.background.default};
    border: 1px solid ${theme.colors.border.muted};
    border-radius: ${theme.radii[4]};
    width: ${(props) => props.width ?? 'auto'};
    transform-origin: var(--radix-popover-content-transform-origin);
    z-index: ${theme.zIndex.interactive};
`;
